<template>
  <div
    v-if="$flags.has('product.rating.review')"
    class="cursor-pointer"
  >
    <etrusted-widget
      class="relative z-[-1]"
      :data-etrusted-widget-id="$config.public.etrustedId[id]"
      :data-sku="sku"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  id: 'plp' | 'pdp' | 'basket';
  sku?: string;
}
defineProps<Props>();

const { $config, $flags } = useNuxtApp();
</script>
